<div class="content-wrap">
  <h3 class="title">
    {{ "device-configurations.title" | translate }}
  </h3>
  <div class="caption">
    <small>
      {{ "device-configurations.description" | translate }}
    </small>
  </div>
  <div class="content">
    <ng-container *ngIf="deviceConfigurations === undefined">
      <div class="loading">
        Loading...
      </div>
    </ng-container>

    <ng-container *ngIf="deviceConfigurations === null">
      <div class="error">
        Error
      </div>
    </ng-container>

    <div class="configs" *ngIf="!!deviceConfigurations">
      <select type="text" class="input" [(ngModel)]="currentDevice" name="select device configuration">
        <option [ngValue]="null" disabled>{{ "device-configurations.select-device" | translate }}
        </option>
        <option [ngValue]="device" *ngFor="let device of deviceConfigurations">{{ device.deviceName }}</option>
      </select>
      <app-device-qr-code class="qr-code" *ngIf="currentDevice" [deviceConfiguration]="currentDevice"/>
    </div>
  </div>

</div>
